module.exports = __webpack_public_path__ + "static/media/ic_opp_info.3250620d.svg";